module.exports = require('radio');



//////////////////
// WEBPACK FOOTER
// ./~/react-pubsub-via-radio.js/radio.js
// module id = 37
// module chunks = 0 1 2 3 4